"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getAcceptedProductState = exports.getAcceptedProduct = exports.getIsBrokenIntegrationWarningVisible = exports.getIsRequiredProspectEmpty = exports.getGiftRequiredProspect = exports.getIsDkimEmailProvider = exports.getGiftEmailProviderId = exports.getGiftEmailProvider = exports.getGiftProposedProducts = exports.getGiftRecipientName = exports.getGiftRecipientProfiles = exports.getGiftDeliveryTracking = exports.getGiftSelectedOptions = exports.getGiftResearchNotice = exports.getRequireEmailIntegration = exports.getGiftCampaign = exports.isAlyceGiftCardSelector = exports.getGiftProduct = exports.getGiftProductId = exports.getGiftCampaignId = exports.getGiftRecipientId = exports.getGiftQuantity = exports.getGiftId = exports.getFormattedUpdateAt = exports.getGiftUpdateAt = exports.getIsResearchProcessing = exports.getGiftResearchType = exports.getGiftInvitationItem = exports.getGiftRecipientCountryId = exports.getIntegrationProvider = exports.getHasCalendarIntegration = exports.getHasEmailIntegration = exports.getIsSendAsUsed = exports.getSendAsUserId = exports.getIsSendAsLocked = exports.getGiftLandingPage = exports.getGiftSenderId = exports.getGiftSender = exports.getGiftOriginalSender = exports.getGiftSendAsSender = exports.getGiftRecipientEmail = exports.getGiftRecipient = exports.getReviewState = exports.getNeedMoreInfoState = exports.getRequirementsState = exports.getRequirementsStateWithVideo = exports.getVideoLandingPageState = exports.getGiftLinkState = exports.getProcessingState = exports.getTemplateDetailsState = exports.getGiftStatusId = exports.getSelectTemplateState = exports.getSelectInvitationTypeState = exports.getSelectProductState = exports.getSafeGift = exports.getProspectDescription = exports.getGiftVidyardVideo = exports.getGiftVideoMessage = exports.getGiftVideoType = exports.getGiftVideo = exports.getGiftEmailTemplate = exports.getIsAllowEditTemplate = exports.getIsGiftContactOptedOut = exports.getIsGiftContactSyncCompleted = exports.getIsGiftContactSyncLoading = exports.getIsGiftContactSyncIdle = exports.getIsGiftSendingCompleted = exports.getIsGiftSendingLoading = exports.getIsGiftSendingIdle = exports.getGiftSFContact = exports.getGiftSendingStatus = exports.getGiftIsLoading = exports.getProposedProducts = exports.getGiftErrors = exports.getGift = exports.getGiftForEdit = exports.getSenderGiftLanguage = exports.getOriginalGift = exports.getGiftState = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var R = _interopRequireWildcard(require("ramda"));

var _reselect = require("reselect");

var _moment = _interopRequireDefault(require("moment"));

var _utils = require("@alycecom/utils");

var _constants = require("../../constants");

var _video = require("../../../constants/video.constants");

var _message = require("./postcard/message/message.selectors");

var _invitationType = require("./invitationType/invitationType.selectors");

var _gift = require("./gift.helpers");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var getGiftState = R.path(['createGift', 'gift']);
exports.getGiftState = getGiftState;
var getOriginalGift = R.compose(R.prop('gift'), getGiftState);
exports.getOriginalGift = getOriginalGift;
var getSenderGiftLanguage = R.compose(R.prop('gl'), getOriginalGift);
exports.getSenderGiftLanguage = getSenderGiftLanguage;

var getGiftForEdit = function getGiftForEdit(gift, stepToEdit) {
  return R.cond([[R.equals(_constants.steps.SELECT_PRODUCT), function () {
    return R.omit(['product_id', 'template', 'message', 'subject', 'gift_invitation_item'], gift);
  }], [R.equals(_constants.steps.SELECT_INVITATION_TYPE), function () {
    return R.omit(['gift_invitation_item'], gift);
  }], [R.equals(_constants.steps.REQUIREMENTS), function () {
    return R.omit(['available_recipient_actions'], gift);
  }], [R.equals(_constants.steps.VIDEO_LANDING_PAGE), function () {
    return _objectSpread(_objectSpread({}, gift), {}, {
      recipient_video: _objectSpread(_objectSpread({}, gift.recipient_video), {}, {
        is_ready: false
      })
    });
  }], [R.T, function () {
    return gift;
  }]])(stepToEdit);
};

exports.getGiftForEdit = getGiftForEdit;
var getGift = R.compose(function (_ref) {
  var gift = _ref.gift,
      stepToEdit = _ref.stepToEdit;
  return getGiftForEdit(gift, stepToEdit);
}, R.pick(['gift', 'stepToEdit']), getGiftState);
exports.getGift = getGift;
var getGiftErrors = R.compose(R.prop('error'), getGiftState);
exports.getGiftErrors = getGiftErrors;
var getProposedProducts = R.compose(R.prop('proposed_products'), getGift);
exports.getProposedProducts = getProposedProducts;
var getGiftIsLoading = R.compose(R.prop('isLoading'), getGiftState);
exports.getGiftIsLoading = getGiftIsLoading;
var getGiftSendingStatus = R.compose(R.prop('giftSendingStatus'), getGiftState);
exports.getGiftSendingStatus = getGiftSendingStatus;
var getGiftSFContact = (0, _reselect.createSelector)(getGiftState, function (_ref2) {
  var giftContact = _ref2.giftContact;
  return giftContact ? giftContact[0] || {} : {};
});
exports.getGiftSFContact = getGiftSFContact;
var getIsGiftSendingIdle = (0, _reselect.createSelector)(getGiftSendingStatus, function (giftSendingStatus) {
  return giftSendingStatus === _constants.GIFT_REQUEST_STATUSES.IDLE;
});
exports.getIsGiftSendingIdle = getIsGiftSendingIdle;
var getIsGiftSendingLoading = (0, _reselect.createSelector)(getGiftSendingStatus, function (giftSendingStatus) {
  return giftSendingStatus === _constants.GIFT_REQUEST_STATUSES.LOADING;
});
exports.getIsGiftSendingLoading = getIsGiftSendingLoading;
var getIsGiftSendingCompleted = (0, _reselect.createSelector)(getGiftSendingStatus, function (giftSendingStatus) {
  return giftSendingStatus === _constants.GIFT_REQUEST_STATUSES.COMPLETED;
});
exports.getIsGiftSendingCompleted = getIsGiftSendingCompleted;
var getIsGiftContactSyncIdle = (0, _reselect.createSelector)(getGiftState, function (_ref3) {
  var giftContactSyncStatus = _ref3.giftContactSyncStatus;
  return giftContactSyncStatus === _constants.GIFT_REQUEST_STATUSES.IDLE;
});
exports.getIsGiftContactSyncIdle = getIsGiftContactSyncIdle;
var getIsGiftContactSyncLoading = (0, _reselect.createSelector)(getGiftState, function (_ref4) {
  var giftContactSyncStatus = _ref4.giftContactSyncStatus;
  return giftContactSyncStatus === _constants.GIFT_REQUEST_STATUSES.LOADING;
});
exports.getIsGiftContactSyncLoading = getIsGiftContactSyncLoading;
var getIsGiftContactSyncCompleted = (0, _reselect.createSelector)(getGiftState, function (_ref5) {
  var giftContactSyncStatus = _ref5.giftContactSyncStatus;
  return giftContactSyncStatus === _constants.GIFT_REQUEST_STATUSES.COMPLETED;
});
exports.getIsGiftContactSyncCompleted = getIsGiftContactSyncCompleted;
var getIsGiftContactOptedOut = (0, _reselect.createSelector)([getIsGiftContactSyncCompleted, getGiftSFContact], function (isGiftContactSyncCompleted, giftContact) {
  return isGiftContactSyncCompleted && giftContact.hasOptedOutOfEmail;
});
exports.getIsGiftContactOptedOut = getIsGiftContactOptedOut;
var getIsAllowEditTemplate = R.compose(R.prop('allowEditTemplate'), getOriginalGift);
exports.getIsAllowEditTemplate = getIsAllowEditTemplate;
var getGiftEmailTemplate = R.compose(R.prop('template'), getGift);
exports.getGiftEmailTemplate = getGiftEmailTemplate;
var getGiftVideo = R.compose(R.prop('recipient_video'), getGift);
exports.getGiftVideo = getGiftVideo;
var getGiftVideoType = R.compose(R.path(['recipient_video', 'video_type']), getGift);
exports.getGiftVideoType = getGiftVideoType;
var getGiftVideoMessage = R.compose(R.path(['recipient_video', 'embed_video']), getGift);
exports.getGiftVideoMessage = getGiftVideoMessage;
var getGiftVidyardVideo = R.compose(R.path(['recipient_video', 'vidyard_video']), getGift);
exports.getGiftVidyardVideo = getGiftVidyardVideo;
var getProspectDescription = R.compose(R.join(', '), R.keys, (0, _utils.renameKeys)({
  capture_date: 'Calendar invite',
  capture_email: 'Email',
  capture_phone: 'Phone number',
  gifter_affidavit: 'Terms to accept',
  gifter_question: 'Questions to ask'
}), R.filter(function (prospectItem) {
  return !!(prospectItem !== null && prospectItem !== void 0 && prospectItem.data);
}), R.omit(['calendar_provider']), R.defaultTo({}), R.prop('prospect'), getGift);
exports.getProspectDescription = getProspectDescription;
var getSafeGift = R.compose(function (gift) {
  return gift || {};
}, getGift);
exports.getSafeGift = getSafeGift;
var getSelectProductState = R.compose(function (gift) {
  if (gift.status_id > _constants.giftStatuses.PRODUCTS_PROPOSED) {
    return _constants.stepState.PASSED;
  }

  if (gift.status_id === _constants.giftStatuses.PRODUCTS_PROPOSED && !gift.product_id) {
    return _constants.stepState.ACTIVE;
  }

  if (gift.status_id === _constants.giftStatuses.PRODUCTS_PROPOSED || gift.product_id) {
    return _constants.stepState.PASSED;
  }

  return _constants.stepState.DISABLED;
}, getSafeGift);
exports.getSelectProductState = getSelectProductState;
var getSelectInvitationTypeState = R.converge(function (gift, selectProductState, invitationTypeState) {
  if (gift.status_id >= _constants.giftStatuses.SCHEDULED) {
    return _constants.stepState.PASSED;
  }

  if (selectProductState === _constants.stepState.PASSED) {
    return invitationTypeState;
  }

  return _constants.stepState.DISABLED;
}, [getSafeGift, getSelectProductState, _invitationType.getInvitationTypeState]);
exports.getSelectInvitationTypeState = getSelectInvitationTypeState;
var getSelectTemplateState = R.converge(function (gift, selectInvitationTypeState) {
  if (gift.status_id > _constants.giftStatuses.PRODUCTS_PROPOSED) {
    return _constants.stepState.HIDDEN;
  }

  if (selectInvitationTypeState !== _constants.stepState.PASSED) {
    return _constants.stepState.DISABLED;
  }

  if (gift.template || gift.message) {
    return _constants.stepState.HIDDEN;
  }

  return _constants.stepState.ACTIVE;
}, [getSafeGift, getSelectInvitationTypeState]);
exports.getSelectTemplateState = getSelectTemplateState;
var getGiftStatusId = R.compose(R.propOr(null, 'status_id'), getGift); // TODO remove when gift reducer will be split

exports.getGiftStatusId = getGiftStatusId;
var getTemplateDetailsState = R.converge(function (messageState, invitationTypeState, selectTemplateState, giftStatusId) {
  if (giftStatusId >= _constants.giftStatuses.SCHEDULED) {
    return _constants.stepState.PASSED;
  }

  if (invitationTypeState !== _constants.stepState.PASSED || selectTemplateState === _constants.stepState.ACTIVE) {
    return _constants.stepState.HIDDEN;
  }

  return messageState;
}, [_message.getMessageState, getSelectInvitationTypeState, getSelectTemplateState, getGiftStatusId]);
exports.getTemplateDetailsState = getTemplateDetailsState;
var getProcessingState = R.compose(function (gift) {
  if (gift.status_id === _constants.giftStatuses.GIFT_CREATED || gift.status_id === _constants.giftStatuses.REVIEW) {
    return _constants.stepState.ACTIVE;
  }

  return _constants.stepState.HIDDEN;
}, getSafeGift);
exports.getProcessingState = getProcessingState;
var getGiftLinkState = R.converge(function (gift, isLinkInvitationType) {
  if (gift.status_id > _constants.giftStatuses.PRODUCTS_PROPOSED && gift.recipient_landing_page && !isLinkInvitationType) {
    return _constants.stepState.PASSED;
  }

  return _constants.stepState.HIDDEN;
}, [getSafeGift, _invitationType.getIsSelectedLinkInvitationType]);
exports.getGiftLinkState = getGiftLinkState;
var getVideoLandingPageState = R.converge(function (gift, templateDetailsState, selectTemplateState) {
  if (gift.status_id > _constants.giftStatuses.PRODUCTS_PROPOSED) {
    return _constants.stepState.PASSED;
  }

  var previousStepPassed = templateDetailsState === _constants.stepState.PASSED && selectTemplateState === _constants.stepState.HIDDEN;

  if (previousStepPassed && !gift.recipient_video.locked) {
    return gift.recipient_video.is_ready ? _constants.stepState.PASSED : _constants.stepState.ACTIVE;
  }

  if (previousStepPassed && gift.recipient_video.locked) {
    var _gift$recipient_video = gift.recipient_video,
        type = _gift$recipient_video.video_type,
        link = _gift$recipient_video.embed_video,
        image = _gift$recipient_video.vidyard_image;
    var hideVideo = type === _video.VIDEO_TYPE_DISABLED || type === _video.VIDEO_TYPE_EMBED && !link || type === _video.VIDEO_TYPE_VIDYARD && !image;
    return hideVideo ? _constants.stepState.HIDDEN : _constants.stepState.PASSED;
  }

  return _constants.stepState.DISABLED;
}, [getSafeGift, getTemplateDetailsState, getSelectTemplateState]);
exports.getVideoLandingPageState = getVideoLandingPageState;
var getRequirementsStateWithVideo = R.converge(function (gift, templateDetailsState, selectTemplateState, videoLandingPageState) {
  if (gift.status_id > _constants.giftStatuses.PRODUCTS_PROPOSED) {
    return _constants.stepState.PASSED;
  }

  var isTemplateStepPassed = templateDetailsState === _constants.stepState.PASSED && selectTemplateState === _constants.stepState.HIDDEN;
  var isVideoStepPassed = [_constants.stepState.PASSED, _constants.stepState.DISABLED, _constants.stepState.HIDDEN].includes(videoLandingPageState);

  if (isVideoStepPassed && isTemplateStepPassed) {
    return gift.available_recipient_actions ? _constants.stepState.PASSED : _constants.stepState.ACTIVE;
  }

  return _constants.stepState.HIDDEN;
}, [getSafeGift, getTemplateDetailsState, getSelectTemplateState, getVideoLandingPageState]);
exports.getRequirementsStateWithVideo = getRequirementsStateWithVideo;
var getRequirementsState = R.converge(function (gift, templateDetailsState, selectTemplateState) {
  if (gift.status_id > _constants.giftStatuses.PRODUCTS_PROPOSED) {
    return _constants.stepState.PASSED;
  }

  var isTemplateStepPassed = templateDetailsState === _constants.stepState.PASSED && selectTemplateState === _constants.stepState.HIDDEN;

  if (isTemplateStepPassed) {
    return gift.available_recipient_actions ? _constants.stepState.PASSED : _constants.stepState.ACTIVE;
  }

  return _constants.stepState.HIDDEN;
}, [getSafeGift, getTemplateDetailsState, getSelectTemplateState]);
exports.getRequirementsState = getRequirementsState;
var getNeedMoreInfoState = R.compose(function (gift) {
  return gift.status_id === _constants.giftStatuses.NEED_MORE_INFO ? _constants.stepState.ACTIVE : _constants.stepState.HIDDEN;
}, getSafeGift);
exports.getNeedMoreInfoState = getNeedMoreInfoState;
var getReviewState = R.converge(function (gift, requirementsState, requirementsStateWithVideo) {
  if (gift.status_id > _constants.giftStatuses.PRODUCTS_PROPOSED) {
    return _constants.stepState.HIDDEN;
  }

  if (requirementsStateWithVideo === _constants.stepState.PASSED) {
    return _constants.stepState.ACTIVE;
  }

  if (requirementsState === _constants.stepState.PASSED) {
    return _constants.stepState.ACTIVE;
  }

  return _constants.stepState.DISABLED;
}, [getSafeGift, getRequirementsState, getRequirementsStateWithVideo]);
exports.getReviewState = getReviewState;
var getGiftRecipient = R.compose(R.propOr(null, 'recipient'), getGift);
exports.getGiftRecipient = getGiftRecipient;
var getGiftRecipientEmail = R.compose(R.propOr(null, 'email'), getGiftRecipient);
exports.getGiftRecipientEmail = getGiftRecipientEmail;
var getGiftSendAsSender = (0, _reselect.createSelector)(getGift, R.propOr(null, 'send_as'));
exports.getGiftSendAsSender = getGiftSendAsSender;
var getGiftOriginalSender = (0, _reselect.createSelector)(getGift, R.propOr(null, 'sender'));
exports.getGiftOriginalSender = getGiftOriginalSender;
var getGiftSender = (0, _reselect.createSelector)(getGiftSendAsSender, getGiftOriginalSender, function (sendAs, sender) {
  return sendAs || sender;
});
exports.getGiftSender = getGiftSender;
var getGiftSenderId = (0, _reselect.createSelector)(getGiftSender, R.propOr(null, 'id'));
exports.getGiftSenderId = getGiftSenderId;
var getGiftLandingPage = R.compose(R.propOr('', 'recipient_landing_page'), getGift);
exports.getGiftLandingPage = getGiftLandingPage;
var getIsSendAsLocked = R.compose(R.pathOr(true, ['send_as', 'is_locked']), getGift);
exports.getIsSendAsLocked = getIsSendAsLocked;
var getSendAsUserId = R.compose(function (gift) {
  return gift.send_as_user_id || gift.sender.id;
}, getGift);
exports.getSendAsUserId = getSendAsUserId;
var getIsSendAsUsed = R.compose(R.converge(function (senderId, sendAsId) {
  return senderId !== sendAsId;
}, [R.path(['sender', 'id']), R.path(['send_as', 'id'])]), getGift);
exports.getIsSendAsUsed = getIsSendAsUsed;
var getHasEmailIntegration = R.compose(R.propOr(false, 'has_integration'), getGiftSender);
exports.getHasEmailIntegration = getHasEmailIntegration;
var getHasCalendarIntegration = R.compose(R.propOr(false, 'has_calendar_integration'), getGiftSender);
exports.getHasCalendarIntegration = getHasCalendarIntegration;
var getIntegrationProvider = R.compose(_gift.mapIntegrationProviders, R.toLower, R.propOr('', 'integration_provider'), getGiftSender);
exports.getIntegrationProvider = getIntegrationProvider;
var getGiftRecipientCountryId = R.pathOr(1, ['createGift', 'gift', 'gift', 'recipient', 'country_id']);
exports.getGiftRecipientCountryId = getGiftRecipientCountryId;
var getGiftInvitationItem = (0, _reselect.createSelector)(getGift, R.prop('gift_invitation_item'));
exports.getGiftInvitationItem = getGiftInvitationItem;
var getGiftResearchType = R.compose(R.propOr(_constants.researchTypes.UNKNOWN, 'research_type'), getGift);
exports.getGiftResearchType = getGiftResearchType;
var getIsResearchProcessing = (0, _reselect.createSelector)(getGiftStatusId, R.equals(_constants.giftStatuses.GIFT_CREATED));
exports.getIsResearchProcessing = getIsResearchProcessing;
var getGiftUpdateAt = R.compose(R.propOr(null, 'update_at'), getGift);
exports.getGiftUpdateAt = getGiftUpdateAt;
var getFormattedUpdateAt = (0, _reselect.createSelector)([getGiftUpdateAt], function (timestamp) {
  return timestamp ? (0, _moment.default)(timestamp).format('hh:mma M/D/YY') : '';
});
exports.getFormattedUpdateAt = getFormattedUpdateAt;
var getGiftId = R.compose(R.propOr(null, 'id'), getGift);
exports.getGiftId = getGiftId;
var getGiftQuantity = R.compose(R.prop('quantity'), getGiftState);
exports.getGiftQuantity = getGiftQuantity;
var getGiftRecipientId = R.compose(R.propOr(null, 'contact_id'), getGift);
exports.getGiftRecipientId = getGiftRecipientId;
var getGiftCampaignId = R.compose(R.propOr(null, 'campaign_id'), getGift);
exports.getGiftCampaignId = getGiftCampaignId;
var getGiftProductId = R.compose(R.propOr(null, 'product_id'), getGift);
exports.getGiftProductId = getGiftProductId;
var getGiftProduct = (0, _reselect.createSelector)(getGiftProductId, getProposedProducts, function (id, products) {
  return (products || []).find(function (product) {
    return product.id === id;
  }) || null;
});
exports.getGiftProduct = getGiftProduct;
var isAlyceGiftCardSelector = R.compose(R.propOr(false, 'is_alyce_gift_card'), getGiftProduct);
exports.isAlyceGiftCardSelector = isAlyceGiftCardSelector;
var getGiftCampaign = (0, _reselect.createSelector)(getGift, R.propOr(null, 'campaign'));
exports.getGiftCampaign = getGiftCampaign;
var getRequireEmailIntegration = (0, _reselect.createSelector)(getGift, R.prop('require_email_integration'));
exports.getRequireEmailIntegration = getRequireEmailIntegration;
var getGiftResearchNotice = R.pathOr('', ['createGift', 'gift', 'gift', 'gift_products_reason']);
exports.getGiftResearchNotice = getGiftResearchNotice;
var getGiftSelectedOptions = R.pathOr('', ['createGift', 'gift', 'gift', 'selectedOptions']);
exports.getGiftSelectedOptions = getGiftSelectedOptions;
var getGiftDeliveryTracking = R.pathOr('', ['createGift', 'gift', 'gift', 'deliveryTracking']);
exports.getGiftDeliveryTracking = getGiftDeliveryTracking;
var getGiftRecipientProfiles = R.pathOr([], ['createGift', 'gift', 'gift', 'recipient', 'profile', 'research_tags']);
exports.getGiftRecipientProfiles = getGiftRecipientProfiles;
var getGiftRecipientName = R.pathOr('', ['createGift', 'gift', 'gift', 'recipient', 'first_name']);
exports.getGiftRecipientName = getGiftRecipientName;
var getGiftProposedProducts = R.pathOr('', ['createGift', 'gift', 'gift', 'proposed_products']);
exports.getGiftProposedProducts = getGiftProposedProducts;
var getGiftEmailProvider = (0, _reselect.createSelector)(getGift, R.propOr(null, 'email_provider'));
exports.getGiftEmailProvider = getGiftEmailProvider;
var getGiftEmailProviderId = R.compose(R.pathOr('', ['email_provider', 'id']), getGift);
exports.getGiftEmailProviderId = getGiftEmailProviderId;
var getIsDkimEmailProvider = R.compose(R.equals(_constants.EMAIL_PROVIDERS.DKIM), getGiftEmailProviderId);
exports.getIsDkimEmailProvider = getIsDkimEmailProvider;
var getGiftRequiredProspect = R.compose(R.pathOr({}, ['required_actions', 'prospect']), getGift);
exports.getGiftRequiredProspect = getGiftRequiredProspect;
var getIsRequiredProspectEmpty = (0, _reselect.createSelector)(getGiftRequiredProspect, R.compose(R.all(R.not), R.values));
exports.getIsRequiredProspectEmpty = getIsRequiredProspectEmpty;
var getIsBrokenIntegrationWarningVisible = (0, _reselect.createSelector)(getGiftEmailProvider, _invitationType.getIsSelectedEmailInvitationType, function (emailProvider, isEmailInvitationType) {
  return (0, R.propOr)(false, 'has_broken_integration', emailProvider) && isEmailInvitationType;
});
exports.getIsBrokenIntegrationWarningVisible = getIsBrokenIntegrationWarningVisible;
var getAcceptedProduct = R.pipe(getSafeGift, function (gift) {
  return gift.acceptedProduct;
});
exports.getAcceptedProduct = getAcceptedProduct;
var getAcceptedProductState = R.pipe(getSafeGift, function (gift) {
  return gift.acceptedProduct ? _constants.stepState.PASSED : _constants.stepState.HIDDEN;
});
exports.getAcceptedProductState = getAcceptedProductState;